import { lazy } from "react";
import Loadable from "app/components/Loadable";

const VideoUpload = Loadable(lazy(() => import("./VideoUpload")));

const VideoUploadRoutes = [{ path: "/video/upload", element: <VideoUpload /> }];

export default VideoUploadRoutes;
